module.exports = __webpack_public_path__ + "img/wxImg.ed8dcac2.png";